<template>
     <div class="flex justify-center items-center flex-wrap h-full g-6 " dir="rtl">
           <div class="mb-4 text-sm text-gray-600 dark:text-gray-400"> 
    <form @submit.prevent="submit">
        <div class="grid gap-4">
            <div class="space-y-2">
                <Label for="mobile" value="توکن ارسال شده به موبایل" />
                <InputIconWrapper>
                    <template #icon>
                        <MailIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input
                        withIcon
                        id="mobile"
                        type="mobile"
                        placeholder="توکن ارسال شده به موبایل"
                        class="block w-full"
                        v-model="resetPasswordForm.token"
                        required
                        autofocus
                        autocomplete="username"
                    />
                </InputIconWrapper>
            </div>

            <div class="space-y-2">
                <Label for="password" value="رمز جدید" />
                <InputIconWrapper>
                    <template #icon>
                        <LockClosedIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input
                        withIcon
                        id="password"
                        type="password"
                        placeholder="رمز جدید"
                        class="block w-full"
                        v-model="resetPasswordForm.password"
                        required
                        autocomplete="new-password"
                    />
                    
                </InputIconWrapper>
            </div>
            
            <div class="space-y-2">
                <Label for="password_confirmation" value="تکرار رمز جدید" />
                <InputIconWrapper>
                    <template #icon>
                        <LockClosedIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input
                        withIcon
                        id="password_confirmation"
                        type="password"
                        placeholder="تکرار رمز جدید"
                        class="block w-full"
                        v-model="resetPasswordForm.confirmPassword"
                        required
                        autocomplete="new-password"
                    />
                    
                </InputIconWrapper>
            </div>

            <div>
                <Button
                    type="submit"
                    class="justify-center w-full"
                    :disabled="resetPasswordForm.processing"
                >بازیابی رمز</Button>
            </div>
        </div>
    </form>
     </div>
    </div>
</template>

<script setup>
import { reactive,defineProps } from 'vue'
import InputIconWrapper from '@/components/InputIconWrapper.vue'
import Button from '@/components/Button.vue'
import Input from '@/components/Input.vue'
import Label from '@/components/Label.vue'
import { MailIcon, LockClosedIcon } from '@heroicons/vue/outline'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification'; // اگر از vue-toastification استفاده می‌کنید

const toast = useToast();
const router = useRouter()
const store = useStore()
// eslint-disable-next-line no-unused-vars
const props = defineProps({
    email: String,
    token: String,
})

const resetPasswordForm = reactive({
    token: '',
    mobile: '',
    password: '',
    confirmPassword: '',
    processing: false
})

const submit = () => {
    if (resetPasswordForm.password !== resetPasswordForm.confirmPassword) {
        toast.error("رمز جدید و تکرار رمز جدید یکسان نیستند!"); // نمایش خطا با toast
        return;
    }

    resetPasswordForm.processing = true;
    store.dispatch('resetpassword', resetPasswordForm)
        .then(() => {
            router.push({ name: 'Login' });
        })
        .catch(() => {
            resetPasswordForm.processing = false;
        });

}
</script>
